import { CompletedCollectible, DraftCollectible } from "@/types/collectibles"
import { COLLECTIBLE_DATA } from "@/util/crypto"

import { parseEther, formatEther } from "viem"

function isZero(value: string): boolean {
  const num = parseFloat(value)
  return !isNaN(num) && num === 0
}

export default function MintPriceText(props: {
  collectible: CompletedCollectible | DraftCollectible
}) {
  if (isZero(props.collectible.costEth)) return "Mint for free"

  const unit = COLLECTIBLE_DATA[props.collectible.chain].unit

  return (
    <>
      Mint for {formatEther(parseEther(props.collectible.costEth))} {unit}
    </>
  )
}
